module.exports = __webpack_public_path__ + "static/media/fillinitinerary.48716954.svg";